import { debounce as debounceReactive } from "../reactives/debounce.js";
export function debounce(options) {
    return (source) => {
        return debounceReactive(source, options);
    };
}
